import { CopyButton } from '@/components/ui/copy-button';
import { ExternalLink } from 'lucide-react';
import { LinkButton } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

import { tokenInfoAtom } from '@/atoms/tokenInfo';
import { atom, useAtom, useAtomValue } from 'jotai';
import { COLORS } from './LiquidityGraph';

export const activeHolderAtom = atom<string | null>(null);

export const TopTenHolders = () => {
  const tokenInfoResult = useAtomValue(tokenInfoAtom);

  const [activeHolder, setActiveHolder] = useAtom(activeHolderAtom);

  if (!tokenInfoResult) return;
  const topTenHolders = tokenInfoResult.top_ten_holders;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Top 10 Holders</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto -mx-4 sm:mx-0">
          <div className="sm:min-w-[600px] sm:w-full p-0">
            <table className="w-full">
              <thead>
                <tr className="text-gray-400 text-sm">
                  <th className="text-left pl-3 pb-4 sm:w-[200px]">Wallet</th>
                  <th className="text-right pb-4 sm:w-[80px]">Share</th>
                  <th className="text-right pr-3 pb-4 sm:w-[100px]">Value (USD)</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-800">
                {topTenHolders.map((holder, index) => (
                  <tr
                    key={index}
                    data-active={`${activeHolder === holder.address}`}
                    style={{ '--hover-color': COLORS[index] + '20' } as React.CSSProperties}
                    className={
                      'cursor-pointer text-white transition-colors hover:bg-[--hover-color] data-[active="true"]:bg-[--hover-color]'
                    }
                    onMouseEnter={() => {
                      setActiveHolder(holder.address);
                    }}
                    onMouseLeave={() => {
                      setActiveHolder(null);
                    }}
                  >
                    <td className="pl-3 py-4">
                      <div className="flex items-center gap-2">
                        <span>{index + 1}</span>
                        <a
                          href={`https://solscan.io/account/${holder.address}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-400 hover:text-blue-300"
                        >
                          <span className="hidden sm:inline">
                            {`${holder.address.slice(0, 8)}...${holder.address.slice(-8)}`}
                          </span>
                          <span className="sm:hidden">
                            {`${holder.address.slice(0, 3)}...${holder.address.slice(-3)}`}
                          </span>
                        </a>
                        <CopyButton
                          value={holder.address}
                          className="hidden sm:flex size-8 ml-auto"
                        />
                        <LinkButton
                          href={`https://solscan.io/account/${holder.address}`}
                          variant="ghost"
                          size="icon"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hidden sm:flex size-8 mr-4"
                        >
                          <ExternalLink />
                        </LinkButton>
                      </div>
                    </td>
                    <td className="py-4 text-right">{Number(holder.percentage).toFixed(2)}%</td>
                    <td className="py-4 pr-3 text-right">${holder.usd}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
